import script from "./UnitModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnitModal.vue?vue&type=script&setup=true&lang=ts"

import "./UnitModal.vue?vue&type=style&index=0&id=0a0cd614&scoped=true&lang=css"

import exportComponent from "F:\\Repos\\Freelance\\site-plan-viewerBH\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a0cd614"]])

export default __exports__